import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormEventRegistration } from 'system/pages/event-registration/list/types';
import TypeEventList from '../type-event-list';
import TypeDestinationList from '../type-destination-list';
import SubscribertList from '../subscriber-list';

interface FiltersEventRegistrationProps {
  filterEventRegistrationForm: FormikProps<FiltersFormEventRegistration>;
}

const FiltersEventRegistration = ({
  filterEventRegistrationForm,
}: FiltersEventRegistrationProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-event-registrations-content"
        id="panel-event-registrations-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterEventRegistrationForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <TypeEventList
                value={filterEventRegistrationForm.values.eventCode || ''}
                onChange={(e) =>
                  filterEventRegistrationForm.setFieldValue('eventCode', e.target.value)
                }
                onBlur={() => filterEventRegistrationForm.setFieldTouched('eventCode', true)}
                error={
                  filterEventRegistrationForm.touched.eventCode &&
                  Boolean(filterEventRegistrationForm.errors.eventCode)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TypeDestinationList
                value={filterEventRegistrationForm.values.destinationCode || ''}
                onChange={(e) =>
                  filterEventRegistrationForm.setFieldValue('destinationCode', e.target.value)
                }
                onBlur={() => filterEventRegistrationForm.setFieldTouched('destinationCode', true)}
                error={
                  filterEventRegistrationForm.touched.destinationCode &&
                  Boolean(filterEventRegistrationForm.errors.destinationCode)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <SubscribertList
                value={filterEventRegistrationForm.values.subscriberCode || ''}
                onChange={(e) =>
                  filterEventRegistrationForm.setFieldValue('subscriberCode', e.target.value)
                }
                onBlur={() => filterEventRegistrationForm.setFieldTouched('subscriberCode', true)}
                error={
                  filterEventRegistrationForm.touched.subscriberCode &&
                  Boolean(filterEventRegistrationForm.errors.subscriberCode)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterEventRegistrationForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersEventRegistration.displayName = 'Filters Event Registration component';

export default FiltersEventRegistration;
